import * as Cookie from "@/localCache/cookie";
import LocalCache from "@/localCache";

/**
 * @FileDescription: 用户数据
 * @Author: zhuangjinshan
 * @Date: 2023-08-16
 * @LastEditors: chenw
 * @LastEditTime: 2025-10-21
 */
export default {
  state: {
    currentUser: null,
    token: '',
    isLoggIn: false, // 是否已登录
    authStatus: '' // 云企业认证状态
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      state.isLoggIn = !!token;
    },
    SET_CURRENT_USER: (state, currentUser) => {
      state.currentUser = currentUser;
    },
    REMOVE_DATA: (state, prop) => {
      state[prop] = null;
    },
    SET_AUTH_STATUS: (state, authStatus) => {
      state.authStatus = authStatus;
    }
  },
  actions: {
    setToken(context, token) {
      Cookie.setToken(token);
      // 同步写入 localStorage，触发其他标签页的 storage 事件（跨标签页同步登录态）
      LocalCache.set('USER_TOKEN', token);
      context.commit('SET_TOKEN', token);
    },
    setCurrentUser({ commit }, currentUser) {
      commit('SET_CURRENT_USER', currentUser);
    },
    setAuthStatus({ commit }, authStatus) {
      commit('SET_AUTH_STATUS', authStatus);
    },
    userClear({ commit }) {
      commit('REMOVE_DATA', 'currentUser');
    },
    /**
     * 退出登录
     */
    logout({ commit }) {
      Cookie.removeToken();
      // 同步清除 localStorage，触发其他标签页的 storage 事件（跨标签页同步退出）
      LocalCache.remove('USER_TOKEN');
      commit('SET_TOKEN', '');
      commit('SET_CURRENT_USER', null);
      commit('SET_AUTH_STATUS', '');
    }
  }
}
